import { FC, ReactNode, useEffect, useState } from 'react'
import { initReactI18next } from 'react-i18next'
import _i18n, { InitOptions } from 'i18next'
import Backend from 'i18next-http-backend'

const getOptions = (language: string): InitOptions => ({
  fallbackLng: {
    default: ['en'],
  },
  lng: language,
  supportedLngs: ['en', 'cs'],
  load: 'languageOnly',
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
    lookupLocalStorage: 'i18nextLng',
  },
  nsSeparator: false,
  keySeparator: '.',
  backend: {
    loadPath: process.env.PUBLIC_URL + '/locales/{{lng}}.json',
  },
})

type Props = {
  language: string
  children: ReactNode
}

export const I18nProvider: FC<Props> = ({ language, children }) => {
  const [i18nLoaded, setI18nLoaded] = useState(false)

  useEffect(() => {
    _i18n
      .use(Backend)
      .use(initReactI18next)
      .init(getOptions(language), () => {
        setI18nLoaded(true)
      })
    // eslint-disable-next-line -- init once on mount only (exhaustive-deps)
  }, [])

  useEffect(() => {
    if (i18nLoaded) {
      void _i18n.changeLanguage(language)
    }
  }, [language, i18nLoaded])

  return i18nLoaded ? <>{children}</> : null
}
